import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import vuetify from "./plugins/vuetify"
import notify from "./helpers/notify"
import dialog from "./helpers/dialogs"
import {HorusAuth} from "./api/api-auth"
import {HorusBilling} from "./api/api-billing"
import appManager from "./helpers/app-manager"
import subsManager from "./helpers/subscriptions"
import L from "leaflet"
import Fragment from "vue-fragment"
import {AUTH_URL, CLIENT_ID, REDIRECT_URI} from "./globals"
import VueTheMask from "vue-the-mask"
import moment from 'moment'
// import * as Sentry from "@sentry/vue";
// import { BrowserTracing } from "@sentry/tracing";

delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
})

export const apiAuth = new HorusAuth(
  AUTH_URL,
  CLIENT_ID,
  REDIRECT_URI,
)

export const apiBilling = new HorusBilling()

export const appMng = appManager()
export const subsMng = subsManager()
export const zipLib = window.zip

Vue.use(Fragment.Plugin)
Vue.use(VueTheMask)

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm')
  }
})

Vue.prototype.$notify = notify
Vue.prototype.$dialog = dialog
Vue.prototype.$apiAuth = apiAuth
Vue.prototype.$appMng = appMng
Vue.prototype.$subsMng = subsMng
Vue.prototype.$zipLib = zipLib

Vue.config.productionTip = false
Vue.config.performance = true

// Sentry.init({
//   Vue,
//   dsn: "https://fcbfdcd2496b47fa86526c33d232caee@sentry.mappa.ag/7",
//   integrations: [
//     new BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracingOrigins: ["dev.local", "platform.dev.mappa.ag", "platform.mappa.ag", /^\//],
//     }),
//   ],
//   environment: ENVIRONMENT,
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// });

export const MainVue = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app")
